var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('big-game'),_c('fire-work',{staticClass:"mt-15",attrs:{"boxHeight":'90%',"boxWidth":'100%'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }